<template>
    <v-card outlined rounded="lg">
        <div class="pa-20 pa-md-24">
            <v-row align="center" class="row--x-large">
                <v-col cols="12" lg="" class="mb-10 mb-lg-0">
                    <h5 class="page-text--lg font-weight-medium text-truncate">
                        {{ value?.title || "비대면 면접" }}
                    </h5>
                    <p class="page-text--sm grey-6--text mt-4">
                        <v-row align="center" class="row--small">
                            <v-col cols="auto">
                                <span> 참여유형: {{ value?.entrance?.typeText }} </span>
                            </v-col>
                            <v-col cols="auto"> <span> / </span> </v-col>
                            <v-col cols="auto">
                                <span> 면접일: {{ (value?.schedule?.at || value?.createdAt)?.toDateTime?.() }} </span>
                            </v-col>
                            <v-col cols="auto"> <span> / </span> </v-col>
                            <v-col cols="auto">
                                <span> 생성일: {{ value?.createdAt?.toDateTime?.() }} </span>
                            </v-col>
                        </v-row>
                    </p>
                </v-col>
                <v-col cols="12" md="9" lg="auto" class="mb-10 mb-md-0">
                    <v-sheet>
                        <p class="page-text--sm grey-9--text mb-4">인원</p>
                        <h5 class="page-text--lg font-weight-medium">{{ value?._interviewees?.length }}명</h5>
                    </v-sheet>
                </v-col>
                <v-col cols="12" md="4" lg="auto">
                    <v-row class="row--small">
                        <v-col cols="6" md="12" lg="auto">
                            <item-enter v-bind="{ value }" v-slot="{ attrs, on }">
                                <v-btn outlined small block class="min-w-lg-100px" v-bind="attrs" v-on="on">
                                    <span>입장하기</span>
                                </v-btn>
                            </item-enter>
                        </v-col>
                        <v-col cols="6" md="12" lg="auto">
                            <v-btn outlined small block color="grey-d" class="min-w-lg-100px" @click="$emit('remove', value)">
                                <span class="grey-6--text">취소하기</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>
import { initInterview } from "@/assets/variables";
import ItemEnter from "./item/item-enter.vue";

export default {
    components: {
        ItemEnter,
    },
    props: {
        value: { type: Object, default: initInterview }, // interview
    },
};
</script>

